export interface AnchorRect {
  top: number;
  left: number;
  width: number;
  bottom: number;
  right: number;
}

export interface PlacementResult {
  top: number;
  left: number;
  maxHeight: number;
  flipped: boolean;
}

const GAP = 6;
const VIEWPORT_PADDING = 8;

export function place(
  anchor: AnchorRect,
  panel: { width: number; height: number },
  viewport: { width: number; height: number },
): PlacementResult {
  const spaceBelow = viewport.height - anchor.bottom - GAP - VIEWPORT_PADDING;
  const spaceAbove = anchor.top - GAP - VIEWPORT_PADDING;
  const flip = spaceBelow < Math.min(panel.height, 240) && spaceAbove > spaceBelow;

  const availableHeight = Math.max(120, Math.min(panel.height, flip ? spaceAbove : spaceBelow));

  let left = anchor.left;
  const overflowsRight = left + panel.width > viewport.width - VIEWPORT_PADDING;
  if (overflowsRight) {
    left = Math.max(VIEWPORT_PADDING, viewport.width - VIEWPORT_PADDING - panel.width);
  }

  const top = flip ? anchor.top - GAP - availableHeight : anchor.bottom + GAP;

  return {
    top: Math.max(VIEWPORT_PADDING, top),
    left,
    maxHeight: availableHeight,
    flipped: flip,
  };
}

export function measurePanel(
  element: HTMLElement,
  preferredHeight: number,
): { width: number; height: number } {
  return {
    width: Math.max(element.offsetWidth, 180),
    height: Math.min(element.offsetHeight || preferredHeight, preferredHeight),
  };
}
